import React, { Component } from 'react';
import { connect } from 'react-redux'; 
import { withTranslation } from 'react-i18next'; 
import Button from 'screens/components/basic/Button';
import DialogInput from 'screens/components/advanced/DialogInput';
import DialogHeaderWithClose from 'screens/components/basic/DialogHeaderWithClose';
import RadioInput from 'screens/components/basic/RadioInput';
import SelectInput from 'screens/components/basic/SelectInput';
import TextInput from 'screens/components/basic/TextInput';
import { addDutchieOrLeaflyAsOnlineOrder } from 'actions/EntityActions';


class POSAddAsDutchieLeafly extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            
        };
    }

    addDutchieOrLeaflyOrder = () => {
        let order = {
            branchId: this.props.branchId,
            orderId: this.props.posOrder.id,
            paidOnline: this.props.dutchieOrLeafly == "Dutchie" ? this.props.dutchiePaidOnline == "online" : false,
            deliveryMethod: this.props.dutchieDeliveryMethod,
            paymentCardType: this.props.dutchiePaidOnline == "online" && this.props.dutchiePaymentCardType ? this.props.dutchiePaymentCardType : 0,
            lastFourDigits: this.props.dutchieLastFourDigits,
            dutchieOrLeafly: this.props.dutchieOrLeafly
        }
        this.props.addDutchieOrLeaflyOrder(order);
        this.props.onClose();
    }

    onClose = () => {
        this.props.onClose();
    }

    render() {
        const { t } = this.props;

        const dutchieDeliveryMethodOptions = [
            {text: t('pos.addAsDutchie.inStorePickup'), value: "inStorePickup"},
            {text: t('pos.addAsDutchie.curbsidePickup'), value: "curbsidePickup"},
            {text: t('pos.addAsDutchie.driveThroughPickup'), value: "driveThroughPickup"}, 
            {text: t('pos.addAsDutchie.shipping'), value: "shipping"},
            {text: t('pos.addAsDutchie.delivery'), value: "delivery"}
        ]
        
        const dutchiePaymentCardType = [
            {text: t('pos.payment.visa'), value: 1},
            {text: t('pos.payment.masterCard'), value: 2},
            {text: t('pos.payment.amex'), value: 3}, 
            {text: t('constants.other'), value: 0}
        ]

        return (
            <DialogInput
            title={<DialogHeaderWithClose text={t('pos.addAsDutchie.addAsOrderType', { type: this.props.dutchieOrLeafly })} classicClass="posDialogClassic" handleClose={() => this.onClose()} />}
                modal={true}
                open={this.props.isOpen}
                className="online-orders-line-dialog checkIn_list"
                handleClose={() => this.onClose()}
                actions={[
                    <Button name="buttonCancel"
                        type="Button"
                        className="corner_X"
                        label=""
                        onTouchTap={() => this.onClose()}
                    />,
                    <Button
                        key={2}
                        className="pull-right space"
                        name="closeOpenOrders"
                        label={t('common.confirm')}
                        primary={true}
                        disabled={this.props.dutchieOrLeafly == "Dutchie" && !this.props.dutchiePaidOnline}
                        onTouchTap={() => this.addDutchieOrLeaflyOrder()} />
                ]}>                               
                <div className="row">
                    { this.props.dutchieOrLeafly == "Dutchie" ?
                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <RadioInput
                                title={t('pos.addAsDutchie.orderIsPaid')}
                                className="refund-inline-radio-btns"
                                groupName="dutchiePaidOnline"
                                options={[{text: t('constants.online'), value: "online"}, {text: t('constants.inStore'), value: "inStore"}]}
                            />
                        </div> : 
                        null
                    }
                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <h5>{t('pos.addAsDutchie.deliveryMethod')}:</h5>
                            <SelectInput 
                                name="dutchieDeliveryMethod"
                                fullWidth={false}
                                defaultValue="inStorePickup"
                                options={dutchieDeliveryMethodOptions}
                            />
                        </div>
                        {this.props.dutchiePaidOnline == "online" &&
                            <div className="col-lg-4 col-md-3 col-sm-3 col-xs-3">
                                <h5>{t('pos.addAsDutchie.cardType')}:</h5>
                                <SelectInput 
                                    name="dutchiePaymentCardType"
                                    fullWidth={false}
                                    defaultValue={2}
                                    options={dutchiePaymentCardType}
                                />
                                <TextInput
                                    name="dutchieLastFourDigits"
                                    fullWidth={false}
                                    label={t('pos.addAsDutchie.lastFourDigits')}
                                    floatingLabelText={t('pos.addAsDutchie.lastFourDigits')}
                                    hintText={t('pos.addAsDutchie.lastFourDigits')}
                                    maxLength={4}
                                />
                            </div>
                        }                                     
                </div>
                <h5 className="danger">{t('pos.addAsDutchie.confirmSettingShippingCost', { dutchieOrLeafly: this.props.dutchieOrLeafly})}</h5>
            </DialogInput>
        )
        
    }
}

function mapStateToProps(state, ownProps) {
    return {
        branchId: state.common.branchId,
        posOrder: state.entity.posOrder,
        dutchiePaidOnline: state.form["dutchiePaidOnline"],
        dutchieDeliveryMethod: state.form["dutchieDeliveryMethod"],
        dutchiePaymentCardType: state.form["dutchiePaymentCardType"],
        dutchieLastFourDigits: state.form["dutchieLastFourDigits"]
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        addDutchieOrLeaflyOrder: (model) => dispatch(addDutchieOrLeaflyAsOnlineOrder(model))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(POSAddAsDutchieLeafly));
